<template>
    <main>
        <section class="slogan">
            <div class="main-title">
                <h1>{{ $t('lp-collection7') }}</h1>
                <div class="main-subtitle">{{ $t('lp-collection8') }}</div>
                <div class="newsletter-container subscribe-form">
                    <div class="email-error" v-if="showErrors2">Enter valid email address</div>
                    <input class="subscribe-form-control" v-model="userEmail2" type="text" :placeholder="$t('footer25')" />
                    <button name="subscribe" aria-label="subscribe button" class="subscribe-btn" v-on:click="sendContact2">
                        <span class="v-btn__content">Sign up</span>
                    </button>
                </div>
            </div>
        </section>

        <section id="why-enprimeur">
            <div class="container1366 padding200 padding80">
                <h2 class="home-title">{{ $t('en-primeur1') }}</h2>
                <div class="title-border"></div>
                <div class="why-vindome-wrapper">
                    <div class="why-text">{{ $t('en-primeur2') }}</div>
                    <v-row>
                        <v-col class="col-md-4 right-half-padding">
                            <div class="how-icon">
                                <div class="card-icon card-icon-tag"></div>
                                <div class="card-text">{{ $t('en-primeur3') }}</div>
                            </div>
                        </v-col>
                        <v-col class="col-md-4 right-half-padding left-half-padding">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="61.3335" width="10.6667" height="10.6667" fill="#907D4C"/>
                                        <rect x="25.7773" y="47.1113" width="10.6667" height="24.8889" fill="#907D4C"/>
                                        <rect x="43.5557" y="32.8887" width="10.6667" height="39.1111" fill="#907D4C"/>
                                        <rect x="61.333" y="8" width="10.6667" height="64" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-text">{{ $t('en-primeur4') }}</div>
                            </div>
                        </v-col>
                        <v-col class="col-md-4 left-half-padding">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M58.75 29.3333H55.625V23.2381C55.625 14.8267 48.625 8 40 8C31.375 8 24.375 14.8267 24.375 23.2381V29.3333H21.25C17.8125 29.3333 15 32.0762 15 35.4286V65.9048C15 69.2571 17.8125 72 21.25 72H58.75C62.1875 72 65 69.2571 65 65.9048V35.4286C65 32.0762 62.1875 29.3333 58.75 29.3333ZM40 56.7619C36.5625 56.7619 33.75 54.019 33.75 50.6667C33.75 47.3143 36.5625 44.5714 40 44.5714C43.4375 44.5714 46.25 47.3143 46.25 50.6667C46.25 54.019 43.4375 56.7619 40 56.7619ZM49.6875 29.3333H30.3125V23.2381C30.3125 18.0267 34.6562 13.7905 40 13.7905C45.3438 13.7905 49.6875 18.0267 49.6875 23.2381V29.3333Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-text">{{ $t('en-primeur5') }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>
        <section id="how-enprimeur">
            <div class="container1366 padding200 padding80">
                <h2 class="home-title">{{ $t('enprimeur04') }}</h2>
                <div class="title-border"></div>
                <div class="how-enprimeur-wrapper">
                    <div class="how-enprimeur-item how-enprimeur-item1">
                        <div class="how-enprimeur-item-title">{{ $t('enprimeur05') }}</div>
                        <div class="how-enprimeur-item-text">{{ $t('enprimeur06') }}</div>
                    </div>
                    <div class="how-enprimeur-item how-enprimeur-item2">
                        <div class="how-enprimeur-item-title">{{ $t('enprimeur07') }}</div>
                        <div class="how-enprimeur-item-text">{{ $t('enprimeur08') }}</div>
                    </div>
                    <div class="how-enprimeur-item how-enprimeur-item3">
                        <div class="how-enprimeur-item-title">{{ $t('enprimeur09') }}</div>
                        <div class="how-enprimeur-item-text">{{ $t('enprimeur10') }}</div>
                    </div>
                    <div class="how-enprimeur-item how-enprimeur-item4">
                        <div class="how-enprimeur-item-title">{{ $t('enprimeur11') }}</div>
                        <div class="how-enprimeur-item-text">{{ $t('enprimeur12') }}</div>
                    </div>
                </div>
            </div>
        </section>
        <section class="lp-register">
            <div class="container1366 padding200 padding80">
                <div>Sign up for our En Primeur news alert</div>
                <div class="newsletter-container subscribe-form">
                    <div class="email-error" v-if="showErrors">Enter valid email address</div>
                    <input class="subscribe-form-control" v-model="userEmail" type="text" :placeholder="$t('footer25')" />
                    <button name="subscribe" aria-label="subscribe button" class="subscribe-btn" v-on:click="sendContact">
                        <span class="v-btn__content">Sign up</span>
                    </button>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import {required, email} from 'vuelidate/lib/validators';
import axios from "axios";

    export default {
        name: 'LPEnPrimeur',
        head: {
            title: 'En Primeur Wine Investment | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'home page-lp-collections'
            }
        },
        validations: {
            userEmail: {
                required,
                email
            },
            userEmail2: {
                required,
                email
            }
        },
        data() {
            return {
                userEmail: '',
                userEmail2: '',
                showErrors: false,
                showErrors2: false,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'
                }
            }
        },
        methods: {
            async sendContact() {
                if (this.userEmail && !this.$v.userEmail.$invalid) {
                    this.showErrors = false;
                    let options = {
                        method: 'POST',
                        url: 'https://forms.raketa.cloud/submit/uVBlbFIcwV',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json;charset=UTF-8'
                        },
                        data: {
                            data: {
                                name: 'new user',
                                email: this.userEmail,
                                message: 'Title: *** LP EN PRIMEUR 1 SIGN UP ***'
                            }
                        }
                    };
                    let response = await axios(options);
                    let responseOK = response && response.status === 200 && response.statusText === 'OK';
                    if (responseOK) {
                        alert('Thank you for signing up!');
                        this.userEmail = '';
                    }
                } else {
                    this.showErrors = true;
                }
            },
            async sendContact2() {
                if (this.userEmail2 && !this.$v.userEmail2.$invalid) {
                    this.showErrors2 = false;
                    let options = {
                        method: 'POST',
                        url: 'https://forms.raketa.cloud/submit/uVBlbFIcwV',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json;charset=UTF-8'
                        },
                        data: {
                            data: {
                                name: 'new user',
                                email: this.userEmail2,
                                message: 'Title: *** LP EN PRIMEUR 1 SIGN UP ***'
                            }
                        }
                    };
                    let response = await axios(options);
                    let responseOK = response && response.status === 200 && response.statusText === 'OK';
                    if (responseOK) {
                        alert('Thank you for signing up!');
                        this.userEmail2 = '';
                    }
                } else {
                    this.showErrors2 = true;
                }
            }
        }
    };
</script>

<style scoped>
.subscribe-btn .v-btn__content {
    justify-content: center;
}
.email-error {
    position: absolute;
    color: red;
    font-size: 12px;
    top: 0;
}
.newsletter-container {
    height: 52px;
    width: 306px;
    margin: 16px auto 0;
    background: #FFFFFF;
    border: 1px solid #D9D7DB;
    border-radius: 10px;
    padding: 8px;
    position: relative;
}
.subscribe-form-control {
    border: 0;
    height: 100%;
    width: calc(100% - 88px);
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: rgba(4, 1, 13, 0.6);
}
.subscribe-btn {
    width: 80px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    position: absolute;
    top: 8px;
    right: 8px;
}
    .how-enprimeur-item {
        display: inline-block;
        width: calc((100% - 84px) / 4);
        vertical-align: top;
        padding-top: 72px;
        text-align: center;
    }
    .how-enprimeur-item1 {
        background: url("../assets/landing/en1.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item2 {
        background: url("../assets/landing/en2.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item3 {
        background: url("../assets/landing/en3.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item4 {
        background: url("../assets/landing/en4.png") no-repeat center top;
    }
    .how-enprimeur-item-title {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #002840;
    }
    .how-enprimeur-item-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #002840;
        margin-top: 8px;
    }
    .how-enprimeur-wrapper {
        padding-bottom: 60px;
        background: url("../assets/landing/timeline.png") no-repeat center bottom;
    }
    #how-enprimeur {
        background: #F7F7F7;
    }
    .why-text {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #002840;
        margin-bottom: 40px;
    }
    .iframe-container {
        width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .iframe-container iframe {
        border: 0;
        width: 100%;
        height: 132px;
        border-radius: 32px;
    }
    .iframe-container2 iframe {
        border: 0;
        width: 100%;
        height: 83px;
        margin-top: 16px;
    }
    .lp-register {
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
        color: white;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }
    h2 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        text-align: center;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    h3 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
        margin-bottom: 8px;
    }
    h3 a {
        color: inherit;
        text-decoration: none;
    }
    .section-how-to-buy h3 {
        margin-top: 37px;
    }

    .card-icon-tag {
        background: url("../assets/landing/tag-svg.svg") no-repeat center;
        background-size: 65px;
    }
    .card-icon {
        height: 80px;
        width: 80px;
        margin: 0 auto 8px;
    }
    .card-text {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        text-align: center;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #002840;
    }
    .right-half-padding {
        padding-right: 25px;
    }
    .left-half-padding {
        padding-left: 25px;
    }

    .home {
        font-size: 14px;
        background-color: #fff;
        color: #000;
    }

    .home ul {
        padding-left: 0;
    }

    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .title-border {
        width: 64px;
        height: 4px;
        background: #ECD9A7;
        margin: 24px auto 40px;
    }

    .hidden {
        display: none;
    }

    /* reset */

    body, div, dl, dt, dd, ul, li, pre, code, form, fieldset, input, textarea, p, blockquote, th, td {
        margin: 0;
        padding: 0;
    }

    table {
        border-spacing: 0;
        border-collapse: collapse;
    }

    fieldset, img, abbr {
        border: 0;
    }

    address, caption, cite, code, dfn, em, strong, th, var {
        font-weight: normal;
        font-style: normal;
    }

    ul li {
        list-style: none;
    }

    caption, th {
        text-align: left;
    }

    button {
        border: none;
        background: none;
    }

    button:hover {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    /* slogan section */

    .slogan {
        height: 480px;
        position: relative;
        background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0) 30%), url('../assets/landing/enprimeur1.svg') no-repeat center bottom;
        background-size: cover;
        margin-top: 80px;
    }

    .main-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 120px auto 0;
        text-align: center;
        max-width: 966px;
    }
    .main-title h1 {
        color: #ffffff;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 0;
    }
    .main-subtitle {
        margin-top: 16px;
        margin-bottom: 32px;
        text-align: center;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 27px;
        color: #ffffff;
    }

    /* START Top Collections */
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        margin-bottom: 24px;
        position: relative;
        text-align: center;
    }

    .why-vindome-wrapper {
        margin-top: 8px;
    }

    @media(max-width: 767px) {
        .home-title {
            font-size: 17px;
            line-height: 17px;
            font-weight: 700;
        }
        .padding200 {
            padding: 0 16px;
        }
        .padding80 {
            padding-top: 32px;
            padding-bottom: 32px;
        }
        .main-title {
            margin-top: 60px;
        }
        .main-title h1 {
            padding: 0 16px;
            font-size: 22px;
            line-height: 30px;
        }
        .main-subtitle {
            font-size: 18px;
            padding: 0 16px;
        }
        .iframe-container {
            width: 320px;
            top: 230px;
        }
        .iframe-container2 {
            width: 320px;
            margin: 16px auto 0;
        }
        .iframe-container2 iframe {
            height: 132px;
        }
        .why-text {
            font-size: 16px;
            line-height: 20px;
        }
        .how-enprimeur-item {
            display: block;
            width: 100%;
        }
        .how-enprimeur-item1, .how-enprimeur-item2, .how-enprimeur-item3 {
            margin-bottom: 32px;
        }
        .how-enprimeur-wrapper {
            background: transparent;
        }
    }
</style>


<style>
    .page-lp-collections .not-logged-btn-wrapper {
        display: none;
    }
    .page-lp-collections .site-navigation-not-logged {
        position: absolute;
        right: 32px;
        top: 24px;
    }
    .page-lp-collections .site-navigation-not-logged li {
        display: none;
    }
    .page-lp-collections .site-navigation-not-logged li.lang-nav {
        display: block;
    }

    @media(max-width: 767px) {
        .home.page-lp-collections .home-top-collections .swiper-container {
            height: 440px !important;
        }
    }
</style>
